document.addEventListener("DOMContentLoaded", () => {
    const animatedElements = document.querySelectorAll(
        ".what_the_we_started,.problematic , .whtare-probiots-sec.dreamteam-sec , .why_are_probiotics, .our_strains, .products .prod-card , .helped-sec h6 , .foundation h3 , .mom h3 , .whtare-probiots-sec .sec-titl, .values h2, .products h2, #typingText , .sec-titl , .common-heading, .recommendedBlog h1 ,.shakey_heading, .common-heading p, .what_the_we_started h4, .problematic .common-heading"
    );
    animatedElements.forEach((el) => {
        const nodes = Array.from(el.childNodes),
            newContent = [];
        nodes.forEach((node) => {
            node.nodeType === Node.TEXT_NODE
                ? node.textContent
                      .trim()
                      .split(/\s+/)
                      .forEach((word) => {
                          word.trim() && newContent.push(`<span>${word}</span> `);
                      })
                : newContent.push(node.outerHTML);
        }),
            (el.innerHTML = newContent.join(""));
    });
    const observerVisible = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const el = entry.target,
                    delay = Array.from(animatedElements).indexOf(el) * 150;
                entry.isIntersecting &&
                    setTimeout(() => {
                        el.classList.add("visible_new");
                    }, delay);
            });
        },
        { threshold: 0.2 }
    );
    animatedElements.forEach((el) => observerVisible.observe(el));
    const observerAnimate = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const spans = entry.target.querySelectorAll("span");
                entry.isIntersecting &&
                    (entry.target.classList.add("animate"),
                    spans.forEach((span, i) => {
                        span.style.transitionDelay = `${i * 0.1}s`;
                    }));
            });
        },
        { threshold: 0.3 }
    );
    animatedElements.forEach((el) => observerAnimate.observe(el));
}),
    document.addEventListener("DOMContentLoaded", () => {
        const elements = document.querySelectorAll(
            ".what_the_we_started h4.common-heading , .problematic h4.common-heading, .whtare-probiots-sec.dreamteam-sec h3.sec-titl, .why_are_probiotics h2.common-heading , .our_strains h3.common-heading"
        );
        elements.forEach((el) => {
            const words = el.textContent.trim().split(/\s+/);
            el.innerHTML = words.map((word) => `<span class="word">${word}</span>`).join(" ");
        });
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const spans = entry.target.querySelectorAll(".word");
                        entry.target.classList.add("animate-in"),
                            spans.forEach((span, i) => {
                                (span.style.transitionDelay = `${i * 0.1}s`), span.classList.add("pop-in");
                            }),
                            observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.5 }
        );
        elements.forEach((el) => observer.observe(el));
    }),
    document.querySelectorAll(".animate_wave").forEach((section) => {
        const wave = section.querySelector(".floating-wave");
        if (!wave) return;
        const waveTemplate = wave.cloneNode(!0);
        function setupWave() {
            section.innerHTML = "";
            const firstWave = waveTemplate.cloneNode(!0);
            section.appendChild(firstWave);
            const waveWidth = firstWave.getBoundingClientRect().width,
                screenWidth = window.innerWidth,
                count = Math.ceil(screenWidth / waveWidth) + 2;
            let x = 0;
            const speed = 1;
            function animate() {
                (x += speed), x >= waveWidth && (x = 0), requestAnimationFrame(animate);
            }
            animate();
        }
        const img = wave.tagName.toLowerCase() === "img" ? wave : wave.querySelector("img");
        img && !img.complete ? (img.onload = setupWave) : setupWave(), window.addEventListener("resize", setupWave);
    });
function autoWave() {
    window.innerWidth <= 768 &&
        document
            .querySelectorAll(".animate_wave svg , .blue-wave_privacy svg")
            .forEach((svg) => svg.setAttribute("viewBox", "0 0 500 1000"));
}
autoWave();
